const ACTION = {
  ADD: 'add',
  EDIT: 'edit',
  INCREMENT: 'increment',
  DECREMENT: 'decrement'
}

export { ACTION }
